import { render, staticRenderFns } from "./offers-slider.vue?vue&type=template&id=83a5a3c0&"
import script from "./offers-slider.vue?vue&type=script&lang=js&"
export * from "./offers-slider.vue?vue&type=script&lang=js&"
import style0 from "./offers-slider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports